import * as types from "../actions/actionTypes";

export default function representatives(state = [], action) {
  switch (action.type) {
    case types.GET_REPRESENTATIVES:
      return action.representatives;

    default:
      return state;
  }
}
